import { render, staticRenderFns } from "./NextPage.vue?vue&type=template&id=b2819160&scoped=true&"
import script from "./NextPage.vue?vue&type=script&lang=ts&"
export * from "./NextPage.vue?vue&type=script&lang=ts&"
import style0 from "./NextPage.vue?vue&type=style&index=0&id=b2819160&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2819160",
  null
  
)

export default component.exports